import { gql } from '@apollo/client';
import type { TypedDocumentNode } from '@apollo/client';

import type { AccountInfo } from './accountInfo.types';

type AccountInfoQuery = {
  accountInfos: AccountInfo;
};

type AccountInfoQueryVariables = {
  userCode: string;
};

export const ACCOUNT_INFO_QUERY: TypedDocumentNode<AccountInfoQuery, AccountInfoQueryVariables> = gql`
  query accountInfos($userCode: String!) {
    accountInfos(userCode: $userCode) {
      id
      academyHash
      firstname
      lastname
      company
      extranetCustomColor
      extranetColorConfiguration {
        id
        primary {
          value
          contrast {
            value
          }
          dark {
            value
          }
          darker {
            value
          }
        }
        secondary {
          value
          contrast {
            value
          }
          dark {
            value
          }
          darker {
            value
          }
        }
        alt_1 {
          value
          contrast {
            value
          }
          dark {
            value
          }
          darker {
            value
          }
        }
        alt_2 {
          value
          contrast {
            value
          }
          dark {
            value
          }
          darker {
            value
          }
        }
        alt_3 {
          value
          contrast {
            value
          }
          dark {
            value
          }
          darker {
            value
          }
        }
      }
      logo {
        url
      }
    }
  }
`;
